import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { PlannedSection } from './components/PlannedSection';
import { PainSection } from './components/PainSection';
import { NotEnoughSection } from './components/NotEnoughSection';
import { TransformSection } from './components/TransformSection';
import { SystemSection } from './components/SystemSection';
import { BonusSection } from './components/BonusSection';
import { PillarsSection } from './components/PillarsSection';
import { ObjectionSection } from './components/ObjectionSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PIXEL_ID } from './components/constants';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
interface AppProps {
  showPurchaseNotifications?: boolean;
}
export function App({
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    const pixelWindow = window as PixelWindow;
    try {
      if (!pixelWindow.fbq) {
        const fbq = ((...args: unknown[]) => {
          if (fbq.callMethod) {
            fbq.callMethod(...args);
          } else {
            fbq.queue?.push(args);
          }
        }) as PixelFunction;
        pixelWindow.fbq = fbq;
        if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript?.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          document.head.appendChild(script);
        }
      }
      pixelWindow.fbq?.('init', PIXEL_ID);
      pixelWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3bk718hkvi07g">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="3qb7hv9vrx0eo" />
      </noscript>

      <div className="w-full bg-pf-cream" data-id="element-2" data-mp="2xud9nrhzh1u1">
        {showPurchaseNotifications && <PurchasePopup data-id="element-3" data-mp="2xsk64l2o2xq9" />}
        <main data-id="element-4" data-mp="2swbtpffutims">
          <Hero data-id="element-5" data-mp="2suqz5ptjhzox" />
          <PlannedSection data-id="element-6" data-mp="2svagb4bd8k1w" />
          <PainSection data-id="element-7" data-mp="2stzdb6pqvgbu" />
          <NotEnoughSection data-id="element-8" data-mp="18e19djimhmji" />
          <TransformSection data-id="element-9" data-mp="18cq41f9j46qa" />
          <SystemSection data-id="element-10" data-mp="18cgc3m4xbphy" />
          <BonusSection data-id="element-11" data-mp="1d4hnz6y6je7g" />
          <PillarsSection data-id="element-12" data-mp="1d4rdktfbbjcm" />
          <ObjectionSection data-id="element-13" data-mp="1d62iwxoeoz5u" />
          <BeforeAfterSection data-id="element-14" data-mp="1d6axqv43aejo" />
          <PricingCard data-id="element-15" data-mp="yg3lix4odrrf" />
          <Guarantee data-id="element-16" data-mp="ygwkhbxe7cz0" />
          <Testimonials data-id="element-17" data-mp="yhepoy2191j2" />
          <FAQ data-id="element-18" data-mp="13eodyador75b" />
          <FinalCTA data-id="element-19" data-mp="13e54zj60jt3f" />
        </main>
        <Footer data-id="element-20" data-mp="13fg6fcbzkord" />
      </div>
    </>;
}